/* Saint Texas color swatches for Horizon's variant picker.

   The hat blanks have ~150 supplier color names ("Charcoal/ Neon Orange",
   "Multicam Arid/ Tan", "Clay/ White-Black") and no Shopify swatch data. Rather
   than fork Horizon's picker, this turns the Color option's buttons into
   native-looking Horizon swatches in place: the real radio inputs stay, so
   price, media, URL and the Customize link keep updating exactly as before.

   Names are split on "/" and "-" into up to three parts and drawn as diagonal
   bands (crown / mesh / bill). Camo and print names get a pattern. Anything
   unrecognised can be fixed from the block's "Color overrides" setting. */
(function () {
  "use strict";
  if (window.__stSwatchesLoaded) return;
  window.__stSwatchesLoaded = true;

  var COLORS = {
    "black": "#1c1c1c", "white": "#f7f7f4", "charcoal": "#3e4144", "grey": "#8e8e8e", "gray": "#8e8e8e",
    "heather grey": "#a8a9ad", "heather": "#a8a9ad", "dark heather grey": "#5d5f63", "dark heather": "#5d5f63",
    "light heather grey": "#c7c8cb", "dark grey": "#4b4d50", "quarry grey": "#8d8a82", "quarry": "#8d8a82",
    "silver": "#b9bcc0", "smoke blue": "#7c8fa3", "grey blue": "#6f8599",
    "navy": "#1f2a44", "midnight navy": "#1a2138", "royal": "#2a4aa8", "royal blue": "#2a4aa8",
    "cobalt blue": "#1f4fa0", "carolina blue": "#7bafd4", "caroline blue": "#7bafd4", "dusty blue": "#7d97ad",
    "ombre blue": "#4f7cac", "blue": "#2f5d9e",
    "red": "#b3202b", "cardinal": "#8c1d2c", "maroon": "#5e1a24", "dusty red": "#b5616a",
    "pink": "#f0a3bc", "pale peach": "#f2c9a9", "lilac": "#c3a6d0",
    "orange": "#e06a1b", "neon orange": "#ff6a13", "dark orange": "#d9601a", "burnt orange": "#cc5500",
    "neon yellow": "#e4f200", "old gold": "#b39150", "amber gold": "#d59b2d", "gold": "#c9a13b",
    "khaki": "#c3b091", "pale khaki": "#d6c9a3", "tan": "#c8ad7f", "buck": "#b08a5a", "biscuit": "#d9c3a0",
    "birch": "#d8cfc0", "oat milk": "#e8dcc6", "trenchcoat": "#a8926c", "caramel": "#b3743f",
    "brown": "#5b3a29", "coffee": "#4b3621", "chocolate chip": "#4e3629", "elmwood": "#8b6f53",
    "russet": "#80461b", "tannin": "#8a5a3c", "clay": "#b66a50",
    "green": "#2f5a36", "dark green": "#1f3b2b", "light green": "#9cbf7a", "kelly": "#2e8b3e",
    "loden": "#4a5a3a", "loden green": "#4a5a3a", "dark loden": "#39442e", "olive": "#6b6b34",
    "olive green": "#5a5f2e", "light olive": "#8a8d5a", "army olive": "#4b5320", "army olive green": "#4b5320",
    "beetle": "#3b3f2f"
  };

  // Base color first, then the blotches.
  var PATTERNS = {
    "multicam alpine": ["#e9ebe6", "#c9cdc6", "#aab0a7", "#f7f7f4"],
    "multicam arid": ["#d8c29d", "#b89f73", "#8f7a55", "#e6d6b8"],
    "multicam black": ["#1c1c1c", "#3a3a3a", "#2a2d2a", "#555555"],
    "multicam green": ["#4e5b3a", "#7b8456", "#2f3a26", "#a19a6e"],
    "multicam tropic": ["#2e4a2c", "#4d6b3b", "#1e2d1c", "#6f8a4e"],
    "multicam": ["#8b8468", "#6d6b4c", "#a89a74", "#4f4a36"],
    "kryptek highlander": ["#8a7358", "#5e4c3a", "#b39b7a", "#3d3226"],
    "kryptek typhon": ["#2a2a2a", "#4a4a4a", "#1a1a1a", "#6a6a6a"],
    "military digital camo": ["#556b2f", "#8f9779", "#3b4a28", "#a9b38f"],
    "mossy oak bottomland": ["#4b3a2a", "#6b5640", "#2e2419", "#8c7a5c"],
    "mossy oak country dna": ["#5a4a36", "#7d6a4c", "#3a4a2c", "#a08c68"],
    "mossy oak": ["#5a4a36", "#7d6a4c", "#3a3024", "#9c8a66"],
    "realtree": ["#6b5a45", "#8f7b5f", "#3f3528", "#b3a07e"],
    "bark duck camo": ["#6b4f36", "#8f6f4f", "#4a3624", "#a88e6a"],
    "blizzard duck camo": ["#e9ebee", "#c9cdd2", "#9aa1a9", "#f7f7f7"],
    "marsh duck camo": ["#5f6a3a", "#8a8f5a", "#3f4628", "#a6a47a"],
    "saltwater duck camo": ["#5d7486", "#8ea3b3", "#3c4e5c", "#b7c4cc"],
    "tiger camo": ["#3f4f2a", "#1f231a", "#6b7a44", "#2a3020"],
    "green camo": ["#3f5230", "#6b7a4a", "#23291c", "#8f9a6a"],
    "army camo": ["#4b5320", "#7a6a4f", "#2f2f23", "#a08f6a"],
    "camo": ["#4b5320", "#7a6a4f", "#2f2f23", "#a08f6a"]
  };
  var PATTERN_KEYS = Object.keys(PATTERNS).sort(function (a, b) { return b.length - a.length; });
  var COLOR_KEYS = Object.keys(COLORS).sort(function (a, b) { return b.length - a.length; });
  var FALLBACK = "#b9b2a6";

  function norm(s) { return String(s || "").toLowerCase().replace(/\s+/g, " ").trim(); }

  function patternLayers(p) {
    return [
      "radial-gradient(circle at 28% 30%, " + p[1] + " 0 17%, transparent 18%)",
      "radial-gradient(ellipse 30% 22% at 70% 62%, " + p[2] + " 0 99%, transparent 100%)",
      "radial-gradient(circle at 42% 78%, " + p[3] + " 0 14%, transparent 15%)",
      "radial-gradient(ellipse 22% 16% at 78% 22%, " + p[2] + " 0 99%, transparent 100%)",
      "radial-gradient(circle at 16% 64%, " + p[3] + " 0 10%, transparent 11%)",
      p[0]
    ];
  }

  // A part is either a color string or a pattern array.
  // Override values: "#hex" (solid), ["#a", "#b"] (bands) or {"pattern": [base, c1, c2, c3]}.
  function fromOverride(v) {
    if (typeof v === "string") return [v];
    if (Array.isArray(v)) return v.filter(function (x) { return typeof x === "string"; });
    if (v && Array.isArray(v.pattern) && v.pattern.length) {
      var p = v.pattern.slice(0, 4);
      while (p.length < 4) p.push(p[p.length - 1]);
      return [p];
    }
    return null;
  }

  function resolvePart(part, overrides) {
    var key = norm(part);
    if (!key) return null;
    if (overrides[key]) { var o = fromOverride(overrides[key]); if (o && o.length) return o[0]; }
    var i;
    for (i = 0; i < PATTERN_KEYS.length; i++) if (key.indexOf(PATTERN_KEYS[i]) !== -1) return PATTERNS[PATTERN_KEYS[i]];
    if (COLORS[key]) return COLORS[key];
    for (i = 0; i < COLOR_KEYS.length; i++) {
      var k = COLOR_KEYS[i];
      if ((" " + key + " ").indexOf(" " + k + " ") !== -1) return COLORS[k];
    }
    return FALLBACK;
  }

  function backgroundFor(name, overrides) {
    var whole = overrides[norm(name)] ? fromOverride(overrides[norm(name)]) : null;
    var parts;
    if (whole && whole.length) {
      parts = whole;
    } else {
      parts = String(name).split(/[\/]| - |-/).map(function (p) { return resolvePart(p, overrides); }).filter(Boolean);
    }
    if (!parts.length) parts = [FALLBACK];
    parts = parts.slice(0, 3);

    var n = parts.length, layers = [], base = null;
    // Solid bands go on top; the first pattern (if any) fills the whole circle underneath.
    parts.forEach(function (p, idx) {
      var from = Math.round((idx / n) * 100), to = Math.round(((idx + 1) / n) * 100);
      if (Array.isArray(p)) {
        if (!base) { base = p; return; }
        p = p[0];
      }
      if (n === 1) { layers.push("linear-gradient(" + p + ", " + p + ")"); return; }
      layers.push("linear-gradient(135deg, transparent " + from + "%, " + p + " " + from + "%, " + p + " " + to + "%, transparent " + to + "%)");
    });
    if (base) layers = layers.concat(patternLayers(base));
    else layers.push(Array.isArray(parts[0]) ? parts[0][0] : parts[0]);
    return layers.join(", ");
  }

  function readConfig(root) {
    var cfg = { names: ["color", "colour"], overrides: {}, images: {}, groupOos: true, oosLabel: "Out of stock" };
    var el = root.querySelector("script[data-st-swatch-config]") || document.querySelector("script[data-st-swatch-config]");
    if (!el) return cfg;
    try {
      var raw = JSON.parse(el.textContent || "{}");
      if (raw.names && raw.names.length) cfg.names = raw.names.map(norm);
      var o = raw.overrides || {};
      Object.keys(o).forEach(function (k) { cfg.overrides[norm(k)] = o[k]; });
      if (typeof raw.groupOos === "boolean") cfg.groupOos = raw.groupOos;
      if (typeof raw.oosLabel === "string") cfg.oosLabel = raw.oosLabel;
      var im = raw.images || {};
      Object.keys(im).forEach(function (k) { if (typeof im[k] === "string") cfg.images[k] = stripWidth(im[k]); });
    } catch (e) {
      if (window.console) console.warn("[st-swatches] Could not read color overrides:", e);
    }
    return cfg;
  }

  // ---- Instant photo switch ----------------------------------------------------------
  // Horizon re-renders the whole gallery from the server after a color is picked, so the photo
  // lagged behind the click. Swap the main photo right away (same URLs the new gallery will use,
  // so it comes straight from the browser cache) and preload a color's photo on hover.
  function stripWidth(u) {
    return String(u || "").replace(/([?&])width=\d+(&)?/, function (m, p1, p2) { return p2 ? p1 : ""; });
  }
  function widthOf(u) { var m = /[?&]width=(\d+)/.exec(u || ""); return m ? m[1] : null; }
  function withWidth(base, w) { return w ? base + (base.indexOf("?") === -1 ? "?" : "&") + "width=" + w : base; }

  function mainPhoto() {
    var imgs = document.querySelectorAll("media-gallery .product-media__image");
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].closest(".dialog-zoomed-gallery, dialog")) return imgs[i];
    }
    return null;
  }

  // Cached per config element AND its contents: the quick-add modal swaps one
  // product's config script for another's without a page load, and a stale
  // colour->photo map would point at the previous product's images.
  var cachedCfg = null, cachedCfgEl = null, cachedCfgText = "";
  function config() {
    var el = document.querySelector("script[data-st-swatch-config]");
    var text = el ? el.textContent || "" : "";
    if (!cachedCfg || el !== cachedCfgEl || text !== cachedCfgText) {
      cachedCfgEl = el;
      cachedCfgText = text;
      cachedCfg = readConfig(document);
    }
    return cachedCfg;
  }

  function isColorPhoto(img, cfg) {
    var base = stripWidth(img.getAttribute("src"));
    for (var k in cfg.images) if (cfg.images[k] === base) return true;
    return false;
  }

  var preloaded = {};
  function preloadColor(name) {
    var cfg = config(), base = cfg.images[name], img = mainPhoto();
    if (!base || !img || preloaded[base]) return;
    preloaded[base] = true;
    var used = img.currentSrc || img.getAttribute("src");
    var pre = new Image();
    pre.decoding = "async";
    pre.src = withWidth(base, widthOf(used));
  }

  function showColor(name) {
    var cfg = config(), base = cfg.images[name], img = mainPhoto();
    if (!base || !img || !isColorPhoto(img, cfg)) return;
    if (stripWidth(img.getAttribute("src")) === base) return;
    var srcset = img.getAttribute("srcset");
    if (srcset) {
      img.setAttribute("srcset", srcset.split(",").map(function (part) {
        var bits = part.trim().split(/\s+/);
        bits[0] = withWidth(base, widthOf(bits[0]));
        return bits.join(" ");
      }).join(", "));
    }
    img.setAttribute("src", withWidth(base, widthOf(img.getAttribute("src"))));
    img.setAttribute("alt", name);
  }

  // ---- Sold-out colours --------------------------------------------------------------
  // Unavailable colours move to the end of the set under their own heading, and lose
  // Horizon's diagonal strikethrough (the CSS in the block fades them instead).
  // Idempotent on purpose: when the order is already right nothing is written, so this
  // can't feed the MutationObserver at the bottom of the file in a loop.
  function groupUnavailable(fs, labelText) {
    var labels = Array.prototype.slice.call(fs.querySelectorAll("label.st-swatch"));
    var out = labels.filter(function (l) {
      var i = l.querySelector('input[type="radio"]');
      return i && i.getAttribute("data-option-available") === "false";
    });
    var head = fs.querySelector(".st-swatch-oos");

    // Nothing to separate if every colour is in stock, or none of them are.
    if (!out.length || out.length === labels.length) {
      if (head && head.parentNode) head.parentNode.removeChild(head);
      return;
    }

    if (!head) {
      head = document.createElement("span");
      head.className = "st-swatch-oos";
      head.setAttribute("aria-hidden", "true");
    }
    var text = labelText == null ? "" : String(labelText);
    if (head.textContent !== text) head.textContent = text;
    head.style.display = text ? "" : "none";

    var kids = Array.prototype.slice.call(fs.children);
    var start = kids.indexOf(head);
    if (start !== -1) {
      var tail = kids.slice(start), ok = tail.length === out.length + 1, i;
      if (ok) for (i = 0; i < out.length; i++) if (tail[i + 1] !== out[i]) { ok = false; break; }
      if (ok) return;
    }

    fs.appendChild(head);
    out.forEach(function (l) { fs.appendChild(l); });
  }

  function enhanceFieldset(fs, cfg) {
    var inputs = fs.querySelectorAll('input[type="radio"][data-option-name]');
    if (!inputs.length) return;
    if (cfg.names.indexOf(norm(inputs[0].getAttribute("data-option-name"))) === -1) return;

    fs.classList.add("st-swatch-set", "variant-option--swatches");
    fs.classList.remove("variant-option--equal-width-buttons");

    var legend = fs.querySelector("legend");
    var valueEl = legend && legend.querySelector(".st-swatch-value");
    if (legend && !valueEl) {
      valueEl = document.createElement("span");
      valueEl.className = "st-swatch-value variant-option__swatch-value";
      legend.appendChild(valueEl);
    }

    Array.prototype.forEach.call(inputs, function (input) {
      var label = input.closest("label");
      if (!label) return;
      var name = input.value;
      if (label.getAttribute("data-st-name") !== name || !label.querySelector(".swatch")) {
        // Horizon's own pill/text spans stay in the DOM (its script may look for them);
        // CSS hides them inside .st-swatch.
        label.classList.add("variant-option__button-label--has-swatch", "st-swatch");
        label.setAttribute("data-st-name", name);
        var sw = label.querySelector(".swatch");
        if (!sw) {
          sw = document.createElement("span");
          sw.className = "swatch swatch--unscaled";
          sw.setAttribute("aria-hidden", "true");
          input.insertAdjacentElement("afterend", sw);
        }
        sw.style.setProperty("--swatch-background", backgroundFor(name, cfg.overrides));
      }
    });

    if (cfg.groupOos) groupUnavailable(fs, cfg.oosLabel);

    var checked = fs.querySelector('input[type="radio"]:checked');
    if (valueEl) {
      var text = checked ? checked.value : "";
      if (valueEl.getAttribute("data-selected") !== text) valueEl.setAttribute("data-selected", text);
      // Only touch the text when it actually changes, and never while a hover preview
      // is showing, so this can't feed the MutationObserver below in a loop.
      if (!valueEl.classList.contains("is-preview") && valueEl.textContent !== text) valueEl.textContent = text;
    }

    if (!fs.__stHover) {
      fs.__stHover = true;
      fs.addEventListener("mouseover", function (e) {
        var l = e.target.closest && e.target.closest("label[data-st-name]");
        if (l) preloadColor(l.getAttribute("data-st-name"));
        var v = fs.querySelector(".st-swatch-value");
        if (l && v && v.textContent !== l.getAttribute("data-st-name")) { v.classList.add("is-preview"); v.textContent = l.getAttribute("data-st-name"); }
      });
      fs.addEventListener("touchstart", function (e) {
        var l = e.target.closest && e.target.closest("label[data-st-name]");
        if (l) preloadColor(l.getAttribute("data-st-name"));
      }, { passive: true });
      fs.addEventListener("mouseleave", function () {
        var v = fs.querySelector(".st-swatch-value");
        if (v) { v.classList.remove("is-preview"); var sel = v.getAttribute("data-selected") || ""; if (v.textContent !== sel) v.textContent = sel; }
      });
    }
  }

  function enhance(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cfg = readConfig(document);
    Array.prototype.forEach.call(scope.querySelectorAll("variant-picker fieldset.variant-option--buttons"), function (fs) {
      enhanceFieldset(fs, cfg);
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; enhance(document); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", schedule);
  else schedule();
  document.addEventListener("change", function (e) {
    if (!(e.target && e.target.closest && e.target.closest("variant-picker"))) return;
    if (e.target.closest(".st-swatch-set") && e.target.value) showColor(e.target.value);
    schedule();
  });
  // Horizon swaps the picker's markup after every selection; put the swatches back.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      if (t.nodeType === 1 && (t.closest && t.closest("variant-picker") || (t.querySelector && t.querySelector("variant-picker")))) { schedule(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.stSwatchBackground = backgroundFor; // handy for checking a name in the console
})();
